import {
  IconButton,
  SectionExpandOutlineIcon,
  SectionCollapseOutlineIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"
import styles from "./GraphFooter.module.scss"
import { useDataAttributionInGraph } from "./useDataAttributionInGraph"
import { usePolyglot } from "src/contexts"

interface Props {
  isGraphCollapsed: boolean;
  setIsGraphCollapsed: (v: boolean) => void;
}

export function GraphFooter(props: Props) {
  const {
    isGraphCollapsed,
    setIsGraphCollapsed,
  } = props

  const polyglot = usePolyglot()
  const dataAttribution = useDataAttributionInGraph()

  const expandGraph = useCallback(
    () => {
      setIsGraphCollapsed(false)
    },
    [setIsGraphCollapsed],
  )

  const collapseGraph = useCallback(
    () => {
      setIsGraphCollapsed(true)
    },
    [setIsGraphCollapsed],
  )

  return (
    <div className={styles.container}>
      <div
        className={styles.dataAttribution}
        id="graph-data-attribution"
      >
        {dataAttribution}
      </div>
      {isGraphCollapsed ? (
        <button
          id="expand-graph-button"
          className={styles.button}
          onClick={expandGraph}
        >
          {polyglot.t("pages.home.graph.footer.show_graph_cta")}
          <SectionExpandOutlineIcon />
        </button>
      ) : (
        <IconButton
          id="collapse-graph-button"
          stylePreset="withoutBackground"
          onClick={collapseGraph}
        >
          <SectionCollapseOutlineIcon />
        </IconButton>
      )}
    </div>
  )
}
